export class OptimizerDefinitionModel {
    id;
    name;
    description;
    protected;
    enabled;
    lastUpdatedOn;
    lastUpdateBy;
    createdOn;
    createdBy;
    tags;
    triggerType;
    senderState;
    triggerOn;
    search;
    output;
}
//# sourceMappingURL=optimizer-definition.js.map